/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Driver_Next_Stop_PhoneInputs */

const vi_dashboard_driver_next_stop_phone = /** @type {(inputs: Dashboard_Driver_Next_Stop_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Điện thoại`)
};

/**

* @param {Dashboard_Driver_Next_Stop_PhoneInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const dashboard_driver_next_stop_phone = /** @type {((inputs?: Dashboard_Driver_Next_Stop_PhoneInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Driver_Next_Stop_PhoneInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_dashboard_driver_next_stop_phone(inputs)
});